export default __webpack_public_path__ + "static/screeny-110-gc-cabrio-4-24a9da8e6e26deaac847b397088d4225.jpg";